import React, { useState } from "react";
import Expenses from "./components/expense/Expenses";
import NewExpense from "./components/NewExpense/NewExpense";
 

const DUMMY_EXPENSES = [
  {
    id: "e1",
    title: "product1",
    amount: 10,
    date: new Date(2022, 9, 2),
  },
  {
    id: "e2",
    title: "product2",
    amount: 80,
    date: new Date(2022, 7, 21),
  },
];

function App() {
  const [expenses, setExpenses] = useState(DUMMY_EXPENSES);
  const addExpenseHandler = (expense) => {
    setExpenses((prevExpenses) => {
      return [expense, ...prevExpenses];
    });
  };

  return (
    <>
      <NewExpense onAddExpense={addExpenseHandler} />
      <Expenses items={expenses} />
    </>
  );
}

export default App;
